/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { createRoot } from "react-dom/client";
import { App } from "./App";
import { initImagePreloader } from "./utils/imagePreloader";
import { progressActions } from "./stores/progressStore";

async function start() {
  const root = createRoot(document.getElementById("root")!);
  root.render(<App />);
  
  // Инициализация приложения
  console.log('🚀 Initializing application...');
  
  // Загружаем текущую задачу
  try {
    await progressActions.loadCurrentTask();
    console.log('📋 Current task loaded successfully');
  } catch (err) {
    console.warn('⚠️ Failed to load current task:', err);
  }
  
  // Запускаем предзагрузку изображений
  initImagePreloader().then(() => {
    console.log('🖼️ All images preloaded successfully');
  }).catch(err => {
    console.warn('⚠️ Some images failed to preload:', err);
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start);
} else {
  start();
}
